import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Layout from "../components/layout";
import { FaChevronDown } from 'react-icons/fa';

const parallax = {
  backgroundImage: 'url(../sciences.jpg)',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover'
};

export default ({ data }) => (
  <div>
    <Layout>
      {/* hero */}
      <header>
        <div className="wrapper">
          <div style={parallax} className="hero parallax" role="img" aria-label={data.hero.data.alt}></div>
          <div className="title text-center">
            <h1 className="display-3 text-light">{data.title.data.title}</h1>
            <a href="#ss" aria-label="Skip to main content"><FaChevronDown size={48} className="mt-5 text-white" /></a>
          </div>
        </div>
      </header>

      <main>
        <div className="anchor" id="ss"></div>
        <div className="container col-xl-6 col-lg-8 my-4 story">
          {/* Section 2 */}
          <section>
            <div className="text-center mx-auto lead mt-5" dangerouslySetInnerHTML={{
              __html: data.intro.data.text.childMarkdownRemark.html,
            }} />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec49kNUsUvADyunk.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec49kNUsUvADyunk.data.alt} />
              <GatsbyImage
                    loading="eager"
                image={data.recG2xBzk5Cl9RoYC.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recG2xBzk5Cl9RoYC.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recKbt4069k6Alt3Z.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec1T7Lt5SkRLTjDE.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec1T7Lt5SkRLTjDE.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recSIXmjTdSbiqIOQ.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recnWm6cxsIBp7o0d.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recnWm6cxsIBp7o0d.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rec00z9IqqmU0XCMN.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
          </section>
          {/* Section 3 */}
          <section>
            <blockquote className="my-5 pullquote">
              <p className="mb-0">{data.recklxuk2pXlzeI9w.data.title}</p>
              <footer className="pullquote-footer">{data.recklxuk2pXlzeI9w.data.text.childMarkdownRemark.rawMarkdownBody}</footer>
            </blockquote>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recerXydO3TRQRXCf.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recerXydO3TRQRXCf.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recClRgUu4loAzaDF.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recWq6OLZogXX7I46.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recWq6OLZogXX7I46.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.reckLTlDdXsnbxV0n.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.reckLTlDdXsnbxV0n.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recTjxXoJX9SJk35p.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.reciVFz8zAQNy0dCU.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.reciVFz8zAQNy0dCU.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recaEu1oChm4U6Bi7.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recDeV4rgowlX29IG.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recDeV4rgowlX29IG.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recnOTanciCK9NKQG.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recnOTanciCK9NKQG.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recPGZ50Tr9uNaLLc.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recn54Px8X8sX0ane.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recn54Px8X8sX0ane.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rectHfKpW2qNHNWdR.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
          </section>
          {/* Section 4 */}
          <section>
            <blockquote className="my-5 pullquote">
              <p className="mb-0">{data.recS2eGmkOttxYJzi.data.title}</p>
              <footer className="pullquote-footer">{data.recS2eGmkOttxYJzi.data.text.childMarkdownRemark.rawMarkdownBody}</footer>
            </blockquote>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.reckz5TiJSAwiBVyg.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.reckz5TiJSAwiBVyg.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recl45Aq50uOuHR06.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recBggwYJ8AOFkNDf.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recBggwYJ8AOFkNDf.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec6UQqIPjHKFFpIX.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec6UQqIPjHKFFpIX.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.reccbsOFRF8gLWPKW.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.reccbsOFRF8gLWPKW.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recNTsx2D9rEca274.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recKkyOen1TfbDNRv.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recKkyOen1TfbDNRv.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recVdWTGdKF2KDT4o.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recVdWTGdKF2KDT4o.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.reclOaB1hJOKUudRm.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recP9vIO8msukNhDN.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recP9vIO8msukNhDN.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rectzqjzrnmZp0IwE.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recrx48BgzfwyG5Si.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recrx48BgzfwyG5Si.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rec3QHduKKGX81S7I.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recSUD8OhzSVgYG9I.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recSUD8OhzSVgYG9I.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec4E0JQgdMh1Ej5h.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec4E0JQgdMh1Ej5h.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recnqmYX5UAmbSLMl.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recnqmYX5UAmbSLMl.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rectL4PxxVqCjO6d2.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec6e7HruDKfgqPVh.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec6e7HruDKfgqPVh.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.reckioIJYrvdC5sSo.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recRqLBXwTqjTo2Vr.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recRqLBXwTqjTo2Vr.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rec14Atdjcgk8Yzmj.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec8q34rxfAyjN8OE.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec8q34rxfAyjN8OE.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recOGQPaDaIyWkK3L.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recq45603TopAPQ4l.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recq45603TopAPQ4l.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recQyu6M5XdTOKDFq.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recQyu6M5XdTOKDFq.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recBpQQJgdZELAUaL.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rectr941Mhe7vdYzP.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rectr941Mhe7vdYzP.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rec5qCZVe72Wp3J9F.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recn96mZHB3ag76Du.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recn96mZHB3ag76Du.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recROusf55cXZlTRA.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recROusf55cXZlTRA.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recAJyuUQJWMsckDU.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recHpEcA6JZjtE5P2.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recHpEcA6JZjtE5P2.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recO6zADZcFdmQEk7.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recO6zADZcFdmQEk7.data.alt}
                className="mt-5" />
            </Fade>
          </section>
          {/* Section 5 */}
          <section>
            <blockquote className="my-5 pullquote">
              <p className="mb-0">{data.recNwe0PY8B8T9Ynr.data.title}</p>
              <footer className="pullquote-footer">{data.recNwe0PY8B8T9Ynr.data.text.childMarkdownRemark.rawMarkdownBody}</footer>
            </blockquote>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recMWA9l3O3cTYOlI.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recMWA9l3O3cTYOlI.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recuf3jTqGZ8bSA1A.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recnoSD85qPd0qCRc.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recnoSD85qPd0qCRc.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recqaFBhRf3JlCq4n.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recqaFBhRf3JlCq4n.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recgK5i6kzVJzesHO.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recD5KE2i3S2edLou.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recD5KE2i3S2edLou.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.reca0J2325ih2gGwB.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.reca0J2325ih2gGwB.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rec4mIBfOo9593Jef.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recSARdILiqFVa6Q7.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recSARdILiqFVa6Q7.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recnBjKZmfVgaRaN4.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recnBjKZmfVgaRaN4.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recpHxO5vGu55zFuo.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
          </section>
          {/* Section 6 */}
          <section>
            <blockquote className="my-5 pullquote">
              <p className="mb-0">{data.rec8eNtbSlmGNhYvN.data.title}</p>
              <footer className="pullquote-footer">{data.rec8eNtbSlmGNhYvN.data.text.childMarkdownRemark.rawMarkdownBody}</footer>
            </blockquote>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.reccqg45t6DtmYUrs.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.reccqg45t6DtmYUrs.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recPJNTQBs6YgYQQ9.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rec6foaEyGaeIlzOc.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rec6foaEyGaeIlzOc.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recBVrv2GKK73v738.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recNGgWOZBVnFjjd4.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recNGgWOZBVnFjjd4.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recliT39bJaW84O6V.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recliT39bJaW84O6V.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recE2NrRopfN7ODig.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recE2NrRopfN7ODig.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recZxW722rX0GQG7i.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recm0JfXTBV7UirT4.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recm0JfXTBV7UirT4.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recUr4YZuabrCGZqc.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recUr4YZuabrCGZqc.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recIDGL22iaFPMFsd.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recRSMWYu1B2l4QZc.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recRSMWYu1B2l4QZc.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.rec9pxxnUCAUzk7k0.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recZDA8KzSmlNJig6.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recZDA8KzSmlNJig6.data.alt}
                className="mt-5" />
            </Fade>
            <div className="mt-2" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recSaYDNQ3MNU3RS9.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recfhIsEX0UbC4eWK.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recfhIsEX0UbC4eWK.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.receBzb7YpDlMNUcJ.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.receBzb7YpDlMNUcJ.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.recCnufdOkxON2vWz.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.recCnufdOkxON2vWz.data.alt}
                className="mt-5" />
            </Fade>
            <Fade>
              <GatsbyImage
                    loading="eager"
                image={data.rectyRipwK9dM5rKH.data.file.localFiles[0].childImageSharp.gatsbyImageData}
                alt={data.rectyRipwK9dM5rKH.data.alt}
                className="mt-5" />
            </Fade>
            <div className="my-5 text-center font-weight-bold" style={{ fontSize: `90%` }} dangerouslySetInnerHTML={{
              __html: data.recHiZ4pT4RU86PTA.data.text.childMarkdownRemark.html,
            }} aria-hidden="true" />
          </section>
        </div>
      </main>
    </Layout>
  </div>
)

export const query = graphql`{
  meta: airtable(recordId: {eq: "recjrRNGN3e7zjlDZ"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
      story
      alt
      metaurl
      description
    }
  }
  hero: airtable(recordId: {eq: "recjrRNGN3e7zjlDZ"}) {
    data {
      alt
    }
  }
  title: airtable(recordId: {eq: "rec9mAs9m1BU1EFGK"}) {
    data {
      title
    }
  }
  intro: airtable(recordId: {eq: "reczpc2POBJEBSudl"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rec49kNUsUvADyunk: airtable(recordId: {eq: "rec49kNUsUvADyunk"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recG2xBzk5Cl9RoYC: airtable(recordId: {eq: "recG2xBzk5Cl9RoYC"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 500
              quality: 80
              transformOptions: {cropFocus: CENTER}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recKbt4069k6Alt3Z: airtable(recordId: {eq: "recKbt4069k6Alt3Z"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rec1T7Lt5SkRLTjDE: airtable(recordId: {eq: "rec1T7Lt5SkRLTjDE"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recSIXmjTdSbiqIOQ: airtable(recordId: {eq: "recSIXmjTdSbiqIOQ"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recnWm6cxsIBp7o0d: airtable(recordId: {eq: "recnWm6cxsIBp7o0d"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: CENTER}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec00z9IqqmU0XCMN: airtable(recordId: {eq: "rec00z9IqqmU0XCMN"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recklxuk2pXlzeI9w: airtable(data: {identifier: {eq: "recklxuk2pXlzeI9w"}}) {
    data {
      title
      text {
        childMarkdownRemark {
          rawMarkdownBody
        }
      }
    }
  }
  recerXydO3TRQRXCf: airtable(recordId: {eq: "recerXydO3TRQRXCf"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recClRgUu4loAzaDF: airtable(recordId: {eq: "recClRgUu4loAzaDF"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recWq6OLZogXX7I46: airtable(recordId: {eq: "recWq6OLZogXX7I46"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 400
              quality: 80
              transformOptions: {cropFocus: CENTER}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  reckLTlDdXsnbxV0n: airtable(recordId: {eq: "reckLTlDdXsnbxV0n"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recTjxXoJX9SJk35p: airtable(recordId: {eq: "recTjxXoJX9SJk35p"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  reciVFz8zAQNy0dCU: airtable(recordId: {eq: "reciVFz8zAQNy0dCU"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recaEu1oChm4U6Bi7: airtable(recordId: {eq: "recaEu1oChm4U6Bi7"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recDeV4rgowlX29IG: airtable(recordId: {eq: "recDeV4rgowlX29IG"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 400
              quality: 80
              transformOptions: {cropFocus: CENTER}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recnOTanciCK9NKQG: airtable(recordId: {eq: "recnOTanciCK9NKQG"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recPGZ50Tr9uNaLLc: airtable(recordId: {eq: "recPGZ50Tr9uNaLLc"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recn54Px8X8sX0ane: airtable(recordId: {eq: "recn54Px8X8sX0ane"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rectHfKpW2qNHNWdR: airtable(recordId: {eq: "rectHfKpW2qNHNWdR"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recS2eGmkOttxYJzi: airtable(data: {identifier: {eq: "recS2eGmkOttxYJzi"}}) {
    data {
      title
      text {
        childMarkdownRemark {
          rawMarkdownBody
        }
      }
    }
  }
  reckz5TiJSAwiBVyg: airtable(recordId: {eq: "reckz5TiJSAwiBVyg"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recl45Aq50uOuHR06: airtable(recordId: {eq: "recl45Aq50uOuHR06"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recBggwYJ8AOFkNDf: airtable(recordId: {eq: "recBggwYJ8AOFkNDf"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec6UQqIPjHKFFpIX: airtable(recordId: {eq: "rec6UQqIPjHKFFpIX"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  reccbsOFRF8gLWPKW: airtable(recordId: {eq: "reccbsOFRF8gLWPKW"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recNTsx2D9rEca274: airtable(recordId: {eq: "recNTsx2D9rEca274"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recKkyOen1TfbDNRv: airtable(recordId: {eq: "recKkyOen1TfbDNRv"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recVdWTGdKF2KDT4o: airtable(recordId: {eq: "recVdWTGdKF2KDT4o"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  reclOaB1hJOKUudRm: airtable(recordId: {eq: "reclOaB1hJOKUudRm"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recP9vIO8msukNhDN: airtable(recordId: {eq: "recP9vIO8msukNhDN"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rectzqjzrnmZp0IwE: airtable(recordId: {eq: "rectzqjzrnmZp0IwE"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recrx48BgzfwyG5Si: airtable(recordId: {eq: "recrx48BgzfwyG5Si"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec3QHduKKGX81S7I: airtable(recordId: {eq: "rec3QHduKKGX81S7I"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recSUD8OhzSVgYG9I: airtable(recordId: {eq: "recSUD8OhzSVgYG9I"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec4E0JQgdMh1Ej5h: airtable(recordId: {eq: "rec4E0JQgdMh1Ej5h"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recnqmYX5UAmbSLMl: airtable(recordId: {eq: "recnqmYX5UAmbSLMl"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rectL4PxxVqCjO6d2: airtable(recordId: {eq: "rectL4PxxVqCjO6d2"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rec6e7HruDKfgqPVh: airtable(recordId: {eq: "rec6e7HruDKfgqPVh"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  reckioIJYrvdC5sSo: airtable(recordId: {eq: "reckioIJYrvdC5sSo"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recRqLBXwTqjTo2Vr: airtable(recordId: {eq: "recRqLBXwTqjTo2Vr"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec14Atdjcgk8Yzmj: airtable(recordId: {eq: "rec14Atdjcgk8Yzmj"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rec8q34rxfAyjN8OE: airtable(recordId: {eq: "rec8q34rxfAyjN8OE"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recOGQPaDaIyWkK3L: airtable(recordId: {eq: "recOGQPaDaIyWkK3L"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recq45603TopAPQ4l: airtable(recordId: {eq: "recq45603TopAPQ4l"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recQyu6M5XdTOKDFq: airtable(recordId: {eq: "recQyu6M5XdTOKDFq"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recBpQQJgdZELAUaL: airtable(recordId: {eq: "recBpQQJgdZELAUaL"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rectr941Mhe7vdYzP: airtable(recordId: {eq: "rectr941Mhe7vdYzP"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 500
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec5qCZVe72Wp3J9F: airtable(recordId: {eq: "rec5qCZVe72Wp3J9F"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recn96mZHB3ag76Du: airtable(recordId: {eq: "recn96mZHB3ag76Du"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recROusf55cXZlTRA: airtable(recordId: {eq: "recROusf55cXZlTRA"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recAJyuUQJWMsckDU: airtable(recordId: {eq: "recAJyuUQJWMsckDU"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recHpEcA6JZjtE5P2: airtable(recordId: {eq: "recHpEcA6JZjtE5P2"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recO6zADZcFdmQEk7: airtable(recordId: {eq: "recO6zADZcFdmQEk7"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recNwe0PY8B8T9Ynr: airtable(data: {identifier: {eq: "recNwe0PY8B8T9Ynr"}}) {
    data {
      title
      text {
        childMarkdownRemark {
          rawMarkdownBody
        }
      }
    }
  }
  recMWA9l3O3cTYOlI: airtable(recordId: {eq: "recMWA9l3O3cTYOlI"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recuf3jTqGZ8bSA1A: airtable(recordId: {eq: "recuf3jTqGZ8bSA1A"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recnoSD85qPd0qCRc: airtable(recordId: {eq: "recnoSD85qPd0qCRc"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recqaFBhRf3JlCq4n: airtable(recordId: {eq: "recqaFBhRf3JlCq4n"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recgK5i6kzVJzesHO: airtable(recordId: {eq: "recgK5i6kzVJzesHO"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recD5KE2i3S2edLou: airtable(recordId: {eq: "recD5KE2i3S2edLou"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  reca0J2325ih2gGwB: airtable(recordId: {eq: "reca0J2325ih2gGwB"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec4mIBfOo9593Jef: airtable(recordId: {eq: "rec4mIBfOo9593Jef"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recSARdILiqFVa6Q7: airtable(recordId: {eq: "recSARdILiqFVa6Q7"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 700
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recnBjKZmfVgaRaN4: airtable(recordId: {eq: "recnBjKZmfVgaRaN4"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recpHxO5vGu55zFuo: airtable(recordId: {eq: "recpHxO5vGu55zFuo"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rec8eNtbSlmGNhYvN: airtable(data: {identifier: {eq: "rec8eNtbSlmGNhYvN"}}) {
    data {
      title
      text {
        childMarkdownRemark {
          rawMarkdownBody
        }
      }
    }
  }
  reccqg45t6DtmYUrs: airtable(recordId: {eq: "reccqg45t6DtmYUrs"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recPJNTQBs6YgYQQ9: airtable(recordId: {eq: "recPJNTQBs6YgYQQ9"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  rec6foaEyGaeIlzOc: airtable(recordId: {eq: "rec6foaEyGaeIlzOc"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recBVrv2GKK73v738: airtable(recordId: {eq: "recBVrv2GKK73v738"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recNGgWOZBVnFjjd4: airtable(recordId: {eq: "recNGgWOZBVnFjjd4"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recliT39bJaW84O6V: airtable(recordId: {eq: "recliT39bJaW84O6V"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 500
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recE2NrRopfN7ODig: airtable(recordId: {eq: "recE2NrRopfN7ODig"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recZxW722rX0GQG7i: airtable(recordId: {eq: "recZxW722rX0GQG7i"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recm0JfXTBV7UirT4: airtable(recordId: {eq: "recm0JfXTBV7UirT4"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 500
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recUr4YZuabrCGZqc: airtable(recordId: {eq: "recUr4YZuabrCGZqc"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recIDGL22iaFPMFsd: airtable(recordId: {eq: "recIDGL22iaFPMFsd"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recRSMWYu1B2l4QZc: airtable(recordId: {eq: "recRSMWYu1B2l4QZc"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rec9pxxnUCAUzk7k0: airtable(recordId: {eq: "rec9pxxnUCAUzk7k0"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recZDA8KzSmlNJig6: airtable(recordId: {eq: "recZDA8KzSmlNJig6"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recSaYDNQ3MNU3RS9: airtable(recordId: {eq: "recSaYDNQ3MNU3RS9"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
  recfhIsEX0UbC4eWK: airtable(recordId: {eq: "recfhIsEX0UbC4eWK"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  receBzb7YpDlMNUcJ: airtable(recordId: {eq: "receBzb7YpDlMNUcJ"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 500
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recCnufdOkxON2vWz: airtable(recordId: {eq: "recCnufdOkxON2vWz"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 600
              quality: 80
              transformOptions: {cropFocus: SOUTH}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  rectyRipwK9dM5rKH: airtable(recordId: {eq: "rectyRipwK9dM5rKH"}) {
    data {
      file {
        localFiles {
          childImageSharp {
            gatsbyImageData(
              height: 800
              quality: 80
              transformOptions: {cropFocus: ATTENTION}
              layout: FULL_WIDTH

                placeholder: BLURRED

              )
          }
        }
      }
      alt
    }
  }
  recHiZ4pT4RU86PTA: airtable(recordId: {eq: "recHiZ4pT4RU86PTA"}) {
    data {
      text {
        childMarkdownRemark {
          html
        }
      }
    }
  }
}`;

export const Head = ({ data }) => (
  <>
    <title>{data.meta.data.story} | Oberlin Photo Stories</title>
    <meta name="title" content={data.meta.data.story} />
    <meta name="description" content={data.meta.data.description} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={data.meta.data.metaurl} />
    <meta property="og:title" content={data.meta.data.story} />
    <meta property="og:description" content={data.meta.data.description} />
    <meta property="og:image" content="https://photo-stories.oberlin.edu/sciences.jpg" />
    <meta property="og:image:width" content="1000" />
    <meta property="og:image:height" content="679" />
    <meta property="og:image:alt" content={data.meta.data.alt} />
    <meta property="fb:app_id" content="1571317633107125" />
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:url" content={data.meta.data.metaurl} />
    <meta property="twitter:title" content={data.meta.data.story} />
    <meta property="twitter:description" content={data.meta.data.description} />
    <meta property="twitter:image" content="https://photo-stories.oberlin.edu/sciences.jpg" />
    <meta property="twitter:image:alt" content={data.meta.data.alt} />
  </>
);